import { compose, lifecycle, withStateHandlers } from 'recompose';
import { injectIntl } from 'react-intl';
import { addProps, addIntlProps } from 'utils/recompose';
import { connect } from 'react-redux';
import { dealerName, mini, currentBrand } from 'reducers/dashboard/selectors';
import { iframeHelpLink } from 'utils/iframeHelpLink';
import combineSelectors from 'utils/combineSelectors';
import messages from './messages';

const mapStateToProps = combineSelectors({
  currentBrand,
  dealerName,
  mini,
});

const initialState = {
  isOpen: false,
  elementRef: null,
};

export function componentDidUpdate(prevState, prevProps) {
  const { toggleCloseOnly, isOpen } = this.props;
  if (isOpen) {
    document.addEventListener('mousedown', toggleCloseOnly);
  }
}

export function componentWillUnmount() {
  const { toggleCloseOnly, isOpen } = this.props;
  if (isOpen) {
    document.removeEventListener('mousedown', toggleCloseOnly);
  }
}

export const toggleOpen = ({ isOpen }) => () => ({ isOpen: !isOpen });
export const toggleCloseOnly = ({ elementRef }) => event => {
  if (elementRef && !elementRef.contains(event.target))
    return { isOpen: false };
};
export const toggleClose = ({ isOpen }) => () => ({ isOpen: false });
export const setElementRef = ({ isOpen }) => elementRef => {
  if (isOpen) return { elementRef: elementRef };
};

const displayPopUpHelpPage = ({ toggleClose, currentBrand }) => () => {
  if (currentBrand) {
    const helpLinkUrl = iframeHelpLink(currentBrand);
    window.open(
      helpLinkUrl,
      'popUpWindow',
      'height=500,width=500,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes',
    );
  }
  toggleClose();
};

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['settings', 'helpCenter'],
  }),
  connect(mapStateToProps),
  withStateHandlers(initialState, {
    toggleOpen,
    setElementRef,
    toggleClose,
    toggleCloseOnly,
  }),
  addProps({ displayPopUpHelpPage }),
  lifecycle({ componentDidUpdate, componentWillUnmount }),
);
